module.exports = __webpack_public_path__ + "static/media/Stationary.5085c763.png";